import React from "react";
import CustomModal from "../../Modal/CustomModal";
import '.././popup.common.css'
import BorderedButton from "../../Buttons/BorderedButton";
import PrimaryButton from "../../Buttons/PrimaryButton";
import styles from "./Style.module.css";

const DiscardPaymentPopup = ({ onClose, onConfirm }) => {
	return (	
	<CustomModal 
		show={true} 
		onHide={onClose}
		>
		<div className={`popup ${styles.dicardPaymentPopup}`}>	
            <div className="header">
                <h2>Are you sure you want to discard this Checkout?</h2>
            </div>

            <div className="body">
                
            </div>

            <div className="footer">
                <BorderedButton 
				text="Cancel" 
				onClick={onClose} 
			/>
			<PrimaryButton
				text="Discard"
				onClick={onConfirm}
			/>
            </div>
        </div>


		
		<div className="d-flex align-items-center button-container modalBtnContainer">
			
		</div>
	</CustomModal>
	);
};

export default DiscardPaymentPopup;
